<template>
  <div class="charge-apply">
    <app-header title="申请开票" @goback="goBack"></app-header>
    <div class="apply-body">
      <div class="invoice-head">
        <div class="head-title">发票金额</div>
        <div class="head-money"><span style="margin-right: 10px;">¥</span><span>{{invoiceMoney}}</span></div>
        <!-- <div class="head-num"><span>发票编号：</span>{{billing_no}}</div> -->
      </div>
      <invoice-type-picker :data-list="invoiceType" :defaultType="currentType" @select="selectType" class="invoice-select"></invoice-type-picker>
      <div class="form-body">
        <div class="form-list">
          <div>开票名称</div>
          <cube-input class="cube-input" v-model="formParams.billingName" placeholder="请输入开票名称"></cube-input>
          <!-- <validator v-model="validator[0]" :model="formParams.billing_name" :rules="rules[0]" ref="validator1"></validator> -->
        </div>
        <div class="form-list">
          <div>纳税人识别号</div>
          <cube-input class="cube-input" v-model="formParams.taxNumber" placeholder="请输入纳税人识别号"></cube-input>
        </div>
        <div class="form-list">
          <div>开票地址</div>
          <cube-input class="cube-input" v-model="formParams.billingAddress" placeholder="请输入开票地址"></cube-input>
        </div>
        <div class="form-list">
          <div>开票电话</div>
          <cube-input class="cube-input" v-model="formParams.billingPhone" type="number" placeholder="请输入开票电话"></cube-input>
        </div>
        <div class="form-list">
          <div>开户行</div>
          <cube-input class="cube-input" v-model="formParams.billingBank" placeholder="请输入开户行"></cube-input>
        </div>
        <div class="form-list">
          <div>开户行账号</div>
          <cube-input class="cube-input" v-model="formParams.billingBankAccount" placeholder="请输入开户行账号"></cube-input>
        </div>
        <div class="form-list">
          <div>发票收货人</div>
          <cube-input class="cube-input" v-model="formParams.linkman" placeholder="请输入收票人"></cube-input>
        </div>
        <div class="form-list" style="margin-bottom: 0;">
          <div>收票人联系方式</div>
          <cube-input class="cube-input" v-model="formParams.contactNumber" placeholder="请输入收票人联系方式"></cube-input>
        </div>
        <area-select-picker ref="areaPicker" @click.native="showAreaPicker" @select="areaSelect"></area-select-picker>
        <div class="form-list">
          <div>收票人详细地址</div>
          <cube-input class="cube-input" v-model="formParams.receiverAddress" placeholder="请输入收票人地址"></cube-input>
        </div>
        <Button @click="submit">提交</Button>
      </div>
    </div>
  </div>
</template>

<script>
import AppHeader from 'components/app-header';
import invoiceTypePicker from './components/invoicetype-picker';
import areaSelectPicker from './components/area-select-picker';
import { Style, Input, Button, Dialog, Validator } from 'cube-ui';
import apis from 'api/index';
import { mapGetters, mapMutations } from 'vuex';

export default {
  components: {
    AppHeader,
    invoiceTypePicker,
    cubeInput: Input,
    Button,
    Validator,
    areaSelectPicker,
  },
  data() {
    return {
      invoiceType: [],
      validator: [undefined],
      rules: [
        { required: true, },
        { required: true, type: 'number', }
      ], // 验证规则
      currentType: 1,
      formParams: {
        billType: 1, // 开票类型：  增值税普通发票：1，增值税专用发票：2  国际：3
        billingName: '', // 开票名称
        taxNumber: '', // 纳税人识别号
        billingAddress: '', // 开票地址
        billingPhone: '', // 开票电话
        billingBank: '', // 开户银行
        billingBankAccount: '', // 开户行账号
        contract_list: '', // 合同 JSON 列表，格式如下
        attachment_list: '', // 附件 JSON 数据
        //收票人信息
        xzqhCode: null,
        receiverAddress: '', //详细地址
        linkman: '', //收票人
        contactNumber: '', //收票人电话
      },
    }
  },
  computed: {
    billing_type() {
      return this.invoiceType.filter(item => item.value === this.currentType)[0].text;
    },
    ...mapGetters(['invoiceList', 'invoiceMoney', 'userAllInfo', 'dictTree'])
  },
  created() {
    this.invoiceType = this.dictTree.bill_type.filter(item => item.value !== 0).map(list => {
      return Object.assign({}, list, {
        text: list.dname
      });
    })
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    selectType(type) {
      this.currentType = type;
      this.formParams.billType = type;
    },
    async submit() {
      try {
        let payRecordIdList = this.invoiceList.map(item => item.id);
        let params = Object.assign({}, this.formParams, { payRecordIdList });

        const res = await apis.saveTicket(params);
        this.showToast('提交成功', 'alert', () => {
          this.setInvoiceList([]);
          this.setInvoiceMoney(0);
          this.$router.push({name: 'charge-record'});
        });
      } catch(err) {
        console.error(err);
      }
    },
    showAreaPicker() {
      this.$refs.areaPicker.showPicker();
    },
    areaSelect(data) {
      this.formParams.xzqhCode = data.id;
    },
    showToast(text, type, confirmFn) {
       this.$createDialog({
        type: 'alert',
        icon: 'cubeic-alert',
        showClose: false,
        title: text,
        onConfirm: confirmFn
      }).show()
    },
    ...mapMutations(['setInvoiceList', 'setInvoiceMoney'])
  }
}
</script>

<style src="./charge.scss" lang="scss" scoped></style>


